import { motion } from "framer-motion";
import { MANIFESTO } from "../../data/content";
import { reveal } from "../../lib/motion";

export const Manifesto = () => {
  return (
    <section
      data-testid="manifesto-section"
      className="grain-overlay bg-cream py-16 md:py-24 lg:py-32"
    >
      <div className="relative z-10 mx-auto max-w-4xl px-5 sm:px-6 lg:px-8">
        <motion.p
          {...reveal()}
          className="text-center text-xs font-semibold uppercase tracking-[0.3em] text-gold"
        >
          O Manifesto AURA
        </motion.p>
        <motion.div {...reveal(0.1)} className="mt-6 text-center">
          <span className="font-serif text-8xl leading-none text-gold/40">&ldquo;</span>
        </motion.div>
        <div className="mt-2 space-y-8 text-center">
          {MANIFESTO.map((p, i) => (
            <motion.p
              key={i}
              {...reveal(0.1 * (i + 1))}
              className={
                i === 0
                  ? "font-serif text-2xl leading-snug text-ink sm:text-3xl"
                  : "text-base leading-relaxed text-mutedink sm:text-lg"
              }
            >
              {p}
            </motion.p>
          ))}
        </div>
        <motion.div {...reveal(0.2)} className="mt-14">
          <div className="gold-hairline mx-auto w-2/3" />
          <p className="mt-10 text-center font-serif text-2xl italic text-teal sm:text-3xl">
            Mulher AURA: o chamado ao sacerdócio real.
          </p>
          <p className="mt-4 text-center text-xs font-semibold uppercase tracking-[0.3em] text-gold">
            A realeza nasceu conosco!
          </p>
        </motion.div>
      </div>
    </section>
  );
};
